import type { InspectionEvent } from 'xstate';
import { assertEvent } from 'xstate';

import type { StateEvents } from './types';

export function assertNavigationEvent<TEVENT extends InspectionEvent>(
	eventP: TEVENT,
): asserts eventP is TEVENT & {
	event:
		| Extract<StateEvents, { type: 'submit' }>
		| Extract<StateEvents, { type: 'back' }>
		| Extract<StateEvents, { type: 'error' }>;
} {
	// https://github.com/statelyai/xstate/issues/5448
	const event: InspectionEvent = eventP;
	assertEvent(event, '@xstate.event');
	if (!['back', 'submit', 'error'].includes(event.event.type) || event.event.target === 'self') {
		throw new Error('not a navigation event');
	}
}
